gsap.registerPlugin(ScrollTrigger);
const $=s=>document.querySelector(s);

/* build bears + ambient */
if(window.OSO_LOGO){
  $('#ctBear').innerHTML=buildOsoLogo('bear','#3a2a1e');
}
if(window.osoAmbient) osoAmbient({sky:true});

/* hero intro */
gsap.set('.ct-title .ln i',{yPercent:112});
gsap.set('.ct-kick',{y:20,autoAlpha:0});
gsap.set('.ct-sub',{y:16,autoAlpha:0});
gsap.set('.ct-scroll',{autoAlpha:0});
gsap.set('#ctBear',{autoAlpha:0,scale:.82,transformOrigin:'50% 80%'});
gsap.timeline({defaults:{ease:'power3.out'},delay:.25})
  .to('.ct-kick',{y:0,autoAlpha:1,duration:.7})
  .to('#ctBear',{autoAlpha:1,scale:1,duration:1,ease:'back.out(1.5)'},'-=.35')
  .to('.ct-title .ln i',{yPercent:0,duration:1,stagger:.14,ease:'power4.out'},'-=.5')
  .to('.ct-zzz',{autoAlpha:.85,duration:.6},'-=.5')
  .to('.ct-sub',{y:0,autoAlpha:1,duration:.8},'-=.4')
  .to('.ct-scroll',{autoAlpha:1,duration:.7},'-=.3')
  .add(()=>{
    gsap.to('#ctBear',{scale:1.03,duration:2.8,repeat:-1,yoyo:true,ease:'sine.inOut',transformOrigin:'50% 82%'});
    gsap.to('.ct-zzz',{y:-10,autoAlpha:.4,duration:2.4,repeat:-1,yoyo:true,ease:'sine.inOut'});
    gsap.to('.ct-scroll .arw',{y:5,duration:1,repeat:-1,yoyo:true,ease:'sine.inOut'});
  });

/* reveal everything as it enters */
gsap.set('.reveal',{y:30});
ScrollTrigger.batch('.reveal',{start:'top 88%',onEnter:els=>gsap.to(els,{y:0,autoAlpha:1,duration:.7,stagger:.09,ease:'power2.out',overwrite:true})});

/* forms → success (UI only, no backend) */
function ctOk(form,msg){const d=document.createElement('div');d.className='ct-ok';
  d.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 12l4 4 10-10"/></svg>'+msg;
  form.replaceWith(d);gsap.from(d,{y:12,autoAlpha:0,scale:.97,duration:.5,ease:'back.out(1.6)'});}
$('#ctForm').addEventListener('submit',e=>{e.preventDefault();ctOk($('#ctForm'),"Message sent, we'll write back within a day or two. Thanks for taking it slow.");});
/* the slow-club section was removed from this page; the footer signup, which is
   a real Shopify customer form, is the only newsletter entry point now */

ScrollTrigger.refresh();
